import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {PaginatorComponent} from "../components/paginator/paginator.component";
import {MaterialModule} from "./material.module";
import {AutosizeModule} from "ngx-autosize";
import {SafeHtmlPipe} from "../pipes/safe-html.pipe";
import {ClipboardModule} from "@angular/cdk/clipboard";
import {ConvertValueToPercentPipe} from "../pipes/convert-value-to-percent.pipe";
import {CurrencyMaskModule} from "ng2-currency-mask";
import {FormatTimePipe} from "../pipes/format-time.pipe";
import {TypeBookingDirectives} from "../directives/type-booking.directives";
import {EmailRelatedBookingDirectives} from "../directives/email-related.directives";
import {StatusBookingDirectives} from "../directives/status-booking.directives";

@NgModule({
    declarations: [
        PaginatorComponent,
        SafeHtmlPipe,
        ConvertValueToPercentPipe,
        FormatTimePipe,
        TypeBookingDirectives,
        StatusBookingDirectives,
        EmailRelatedBookingDirectives
    ],
    imports: [
        CommonModule,
        AutosizeModule,
        TranslateModule,
        ClipboardModule,
        MaterialModule
    ],
    exports: [
        TranslateModule,
        AutosizeModule,
        SafeHtmlPipe,
        MaterialModule,
        ClipboardModule,
        PaginatorComponent,
        TypeBookingDirectives,
        ConvertValueToPercentPipe,
        FormatTimePipe,
        StatusBookingDirectives,
        EmailRelatedBookingDirectives,
        CurrencyMaskModule
    ]
})
export class SharedModule {
}
